import DataTable from 'react-data-table-component';   
import type { TableProps } from 'react-data-table-component';
type PaginationChangeRowsPerPage = NonNullable<TableProps<any>['onChangeRowsPerPage']>;
    
interface ReportDataProps {
    reportData:any
    handlePageChange:PaginationChangeRowsPerPage | undefined
    handlePerRowsChange:PaginationChangeRowsPerPage | undefined
}

const SearchCountOnModel: React.FC<ReportDataProps> = ({reportData, handlePageChange, handlePerRowsChange}):any => {
    
    //Custom Style for the data table
    const customStyles = {
        headCells: {
            style: {
                fontSize: "15px",
                fontWeight: "700"
            },
        },
    };

    //Column Declaraion for the data table
    const columns: any = [

        {
            name: <div>Model</div>,
            wrap: true,
            sortable: false,
            keyName: 'model', 
            selector: (row: {model: string,make: string}) => `${row.make} ${row.model}`,

        },
        {
            name: 'Count',
            selector: (row: { vehicleCount: string; }) => row.vehicleCount,
            sortable: false,
        },
    ];

    return (<>
        <br></br>
        <DataTable
                columns={columns}
                data={reportData.rows}
                striped={true}
                pagination
                paginationServer
                paginationTotalRows={reportData.count}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                highlightOnHover={true}
                customStyles={customStyles}
            />
        
    </>)

}
export default SearchCountOnModel